import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import {
  updateArEffect,
  createArEffect,
} from "../../store/arEffects/action";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Switch,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { CLOSE_AR_EFFECTS_DIALOG } from "../../store/arEffects/types";

// react dropzone
import ReactDropzone from "react-dropzone";
import { baseURL } from "../../util/Config";
import { event } from "jquery";

const ArEffectDialog = (props) => {
  const { dialog, dialogData } = useSelector((state) => state.arEffects);
  const [mongoId, setMongoId] = useState("");
  const [name, setName] = useState("");
  const [errors, setError] = useState("");

  const [editImagePath, setEditImagePath] = useState("");
  const [editImageData, setEditImageData] = useState("");
  const [editPreviewImageData, setEditPreviewImageData] = useState("");
  const [editPreviewImagePath, setEditPreviewImagePath] = useState("");

  const [addPreviewImagePath, setAddPreviewImagePath] = useState("");
  const [addPreviewImageData, setAddPreviewImageData] = useState("");
  const [addImageData, setAddImageData] = useState("");
  const [addImagePath, setAddImagePath] = useState("");

  const [isActive, setIsActive] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (dialogData) {
      setIsActive(dialogData.isActive);
      setMongoId(dialogData._id);
      setName(dialogData.name);
      setEditImagePath(baseURL + dialogData.image);
      setEditPreviewImagePath(baseURL + dialogData.preview);
    }
  }, [dialogData]);

  useEffect(
    () => () => {
      setError("");
      setName("");
      setEditImageData(null);
      setEditImagePath(null);
      setEditPreviewImageData(null);
      setEditPreviewImagePath(null);
      setAddImageData(null);
      setAddImagePath(null);
      setAddPreviewImageData(null);
      setAddPreviewImagePath(null);
    },
    [dialog]
  );


  const closePopup = () => {
    dispatch({ type: CLOSE_AR_EFFECTS_DIALOG });
  };

  const handleSubmit = () => {
    if (!name) {
      const errors = {};
      if (!name) errors.name = "Name is Required";
      // if (images.length === 0) errors.images = "Please select an Image!";
      // TODO: Image validation
      return setError({ ...errors });
    } else {
      const formData = new FormData();
      if (dialogData) {
        // Only append deepAr if it has been edited
        if (editImageData) {
          formData.append("deepAr", editImageData);
        }
        // Only append preview if it has been edited
        if (editPreviewImageData) {
          formData.append("preview", editPreviewImageData);
        }
      } else {
        formData.append("deepAr", addImageData);
        formData.append("preview", addPreviewImageData)
      }
      formData.append("name", name);
      formData.append("isActive", isActive.toString());
      if (dialogData) {
        props.updateArEffect(mongoId, formData);
      } else {
        props.createArEffect(formData);
      }
      closePopup();
    }
  };



  // for preview image
  const handleInputAddImage = (e) => {
    if (e.target.files[0]) {
      setAddImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setAddImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };


  // for preview image
  const handleInputAddImagePreview = (e) => {
    if (e.target.files[0]) {
      setAddPreviewImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setAddPreviewImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleInputEditImage = (e) => {
    if (e.target.files[0]) {
      setEditImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setEditImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleInputEditImagePreview = (e) => {
    if (e.target.files[0]) {
      setEditPreviewImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setEditPreviewImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  }


  return (
    <>
      <Dialog
        open={dialog}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        disableScrollLock
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4">AR Effect</span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="form-group">
                  <label className="text-gray mb-2">Name</label>

                  <input
                    type="text"
                    className="form-control"
                    required=""
                    placeholder="Name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          name: "Name is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          name: "",
                        });
                      }
                    }}
                  />

                  {errors.name && (
                    <div className="ml-2 mt-1">
                      {errors.name && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.name}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>



                <div className="form-group mt-4">
                  <label className="text-gray mb-2">Is Active</label>

                  <Switch
                    checked={isActive}
                    onChange={(event) => setIsActive(event.target.checked)}
                    name="checkedA"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />

                </div>

                {dialogData ? (

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="form-group mt-4">
                      <label className="mb-2 text-gray">Select DeepAR file</label>
                      <input
                        type="file"
                        accept=".deepar"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputEditImage}
                      />
                    </div>

                    {/* preview image */}
                    <div className="form-group mt-4">
                      <label className="mb-2 text-gray">Select Preview Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputEditImagePreview}
                      />
                      {editPreviewImagePath && (
                        <>
                          <img
                            src={editPreviewImagePath}
                            className="mt-3 rounded float-left mb-2"
                            height="100px"
                            width="100px"
                          />
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="form-group mt-4" style={{ display: 'flex', flexDirection: 'column' }}>
                      <label className="mb-2 text-gray">Select DeepAR file</label>
                      <input
                        type="file"
                        accept=".deepar"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputAddImage}
                      />
                    </div>

                    {/* preview image */}
                    <div className="form-group mt-4">
                      <label className="mb-2 text-gray">Select Preview Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputAddImagePreview}
                      />
                      {addPreviewImagePath && (
                        <>
                          <img
                            src={addPreviewImagePath}
                            className="mt-3 rounded float-left mb-2"
                            height="100px"
                            width="100px"
                          />
                        </>
                      )}
                    </div>
                  </>
                )}

                <div className={editImagePath ? "mt-5 pt-5" : "mt-5"}>
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { updateArEffect, createArEffect })(
  ArEffectDialog
);
